import type { NotificationSeverity } from '../../api/types';

/**
 * Severity -> theme token map shared by the bell dot and the alert
 * banner (ADR-0028 §4). Error is the loud red case; Warning amber;
 * Info a calm accent. Maps onto the existing `state-*` design tokens so
 * notifications read the same as the rest of the admin chrome.
 */
export interface SeverityStyle {
    /** Solid dot / accent color class (text-* or bg-* via `dot`/`text`). */
    dot: string;
    text: string;
    /** Banner surface tint (border + bg). */
    banner: string;
}

const STYLES: Record<NotificationSeverity, SeverityStyle> = {
    Info: {
        dot: 'bg-accent',
        text: 'text-accent',
        banner: 'border-accent/40 bg-accent-glow',
    },
    Warning: {
        dot: 'bg-state-pending',
        text: 'text-state-pending',
        banner: 'border-state-pending/40 bg-state-pending/10',
    },
    Error: {
        dot: 'bg-state-failed',
        text: 'text-state-failed',
        banner: 'border-state-failed/50 bg-state-failed/10',
    },
};

export function severityStyle(severity: NotificationSeverity): SeverityStyle {
    return STYLES[severity] ?? STYLES.Info;
}
